__turbopack_context__.v({
  "emptyState__tile": "EmptyState-module__ylemmG__emptyState__tile",
  "emptyState__tile__dot1": "EmptyState-module__ylemmG__emptyState__tile__dot1",
  "emptyState__tile__dot2": "EmptyState-module__ylemmG__emptyState__tile__dot2",
  "emptyState__tile__dot3": "EmptyState-module__ylemmG__emptyState__tile__dot3",
  "emptyState__tile__dot4": "EmptyState-module__ylemmG__emptyState__tile__dot4",
  "emptyState__tile__dot5": "EmptyState-module__ylemmG__emptyState__tile__dot5",
  "emptyState__tile_container": "EmptyState-module__ylemmG__emptyState__tile_container",
});
